__turbopack_context__.v({
  "drawer": "HzoEcW_drawer",
});
